import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

function Icon(props) {
	return (
		<SvgIcon {...props} viewBox="0 0  50 50">
			<path d="M30 44v2h6v-2h-3.1c.4-.6 3.1-3.3 3.1-5 0-1.4-1.1-3-3-3-1.3 0-3 1.4-3 3h2c0-.4.7-1 1-1 .7 0 1 .6 1 1C34 39.9 30 44 30 44zM25 43h-6V13H6V7h32v6H25V43z" />
		</SvgIcon>
	);
}

export default Icon;
